module.exports = __webpack_public_path__ + "static/media/footer-icon-dark-1.23b2cfff.svg";